import { cn } from "@/lib/chillnn/cn";

type Props = {
	inactive: boolean;
	children: React.ReactNode;
};

export const ScConnectedInactiveSettings = ({ inactive, children }: Props) => {
	if (!inactive) {
		return <>{children}</>;
	}

	return (
		<div className="relative">
			<fieldset
				disabled
				className={cn(
					"min-w-0 rounded-md border border-dashed border-zinc-300 bg-zinc-50 p-0",
					"pointer-events-none select-none opacity-40 grayscale",
				)}
			>
				{children}
			</fieldset>

			<div
				aria-hidden
				className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-md bg-zinc-100/50"
			>
				<p className="rounded-md border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-zinc-500 shadow-sm">
					サイトコントローラー連携中はこの設定は使用されません
				</p>
			</div>
		</div>
	);
};

ScConnectedInactiveSettings.displayName = "ScConnectedInactiveSettings";
